import React, { useEffect, useState } from "react";
// router
import { useParams, useNavigate } from "react-router";
// redux
import { useSelector } from "react-redux";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// componennts
import {
    PageTitle,
    SubmitButton,
    InputField,
    SelectCategory,
    ThreeDotsLoader,
} from "../../components";
// schema
import { addQuestionSchema } from "../../schemes/question/addQuestionSchema";
import { ReduxUserReducerState } from "../../types/global";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";
// form values type
type FormValues = {
    question: string;
    answer: string;
    category: any | null;
    is_disabled: boolean;
};

const EditQuestion = () => {
    const navigate = useNavigate();
    const { questionId } = useParams();
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            question: "",
            answer: "",
            category: null,
            is_disabled: false,
        },
        resolver: yupResolver(addQuestionSchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        getValues,
        control,
        reset,
        watch,
        formState: { errors },
        handleSubmit,
    } = form;
    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setSubmitting(true);
        EnhancedAxios(null, userToken)
            .put(`/admin/faq/${questionId}`, data)
            .then((response: AxiosResponse) => {
                setSubmitting(false);
                successAlert("تم تعديل سؤال ");
                navigate(-1);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    // get current question data
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/admin/faq/${questionId}`)
            .then((response: AxiosResponse) => {
                setLoading(false);
                reset({
                    question: response.data.question,
                    answer: response.data.answer,
                    category: response.data.category,
                    is_disabled: response.data.is_disabled,
                });
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, []);
    // page is loading
    if (loading) return <ThreeDotsLoader />;
    return (
        <Stack gap="20px">
            <PageTitle title="تعديل سؤال شائع" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        type="text"
                        registration={{ ...register("question") }}
                        label="السؤال"
                        errorMessage={errors?.question?.message}
                    />
                    <InputField
                        type="text"
                        registration={{ ...register("answer") }}
                        label="الاجابة"
                        errorMessage={errors?.answer?.message}
                        multiline={true}
                        minRows={2}
                        maxRows={6}
                    />
                    <SelectCategory
                        getValues={getValues}
                        errorMessage={errors?.category?.message?.toString()}
                        setValue={setValue}
                        control={control}
                        multiple={false}
                        name="category"
                        categoriesParent={
                            process.env.REACT_APP_FAQS_CATS_PARENT_ID
                        }
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="تعديل" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default EditQuestion;
